var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgClearCaseDark(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1782_6530)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.05 10C0.05 4.50015 4.50058 0.05 10 0.05C15.4998 0.05 19.95 4.50054 19.95 10C19.95 15.4998 15.4994 19.95 10 19.95C4.50015 19.95 0.05 15.4995 0.05 10ZM1.5125 10C1.5125 14.6914 5.30895 18.4875 10 18.4875C14.6914 18.4875 18.4875 14.6911 18.4875 10C18.4875 5.3086 14.6911 1.5125 10 1.5125C5.3086 1.5125 1.5125 5.30891 1.5125 10Z",
    fill: "white",
    fillOpacity: 0.7,
    stroke: "#1E2526",
    strokeWidth: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.3858 12.3519L13.4211 12.3165L13.3858 12.3519C13.6714 12.6374 13.6714 13.1004 13.3858 13.386C13.1002 13.6716 12.6371 13.6715 12.3517 13.386L12.3517 13.386L10.0351 11.0695L9.99979 11.0342L9.96444 11.0695L7.64792 13.386L7.64791 13.386C7.36244 13.6715 6.89945 13.6716 6.61378 13.386C6.3282 13.1004 6.32823 12.6375 6.61382 12.3519L8.93031 10.0354L8.96566 10L8.93031 9.96466L6.61382 7.64818L6.61382 7.64818C6.32823 7.36263 6.32823 6.89964 6.61379 6.61404C6.89934 6.32846 7.3624 6.32846 7.64791 6.61404L7.64792 6.61405L9.96444 8.93053L9.99979 8.96589L10.0351 8.93053L12.3517 6.61405L12.3163 6.57869L12.3517 6.61404C12.6372 6.3285 13.1002 6.32845 13.3858 6.61405C13.6714 6.89964 13.6713 7.36263 13.3858 7.64818L11.0693 9.96466L11.0339 10L11.0693 10.0354L13.3858 12.3519Z",
    fill: "white",
    fillOpacity: 0.7,
    stroke: "#1E2526",
    strokeWidth: 0.1
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1782_6530"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClearCaseDark);
export default __webpack_public_path__ + "static/media/ClearCaseDark.930931997d2768c09774804d91d1723c.svg";
export { ForwardRef as ReactComponent };